import * as React from 'react'
import cx from 'classnames'
import styles from './styles.module.scss'
import GreenCheckMark from '../../../../../../svg/check-mark-green.svg'
import Svg from '../../../Svg'
import {OrderLookProduct} from '../../types/eventData'

export interface OrderItemCardProps {
  item: OrderLookProduct
  onOrderItemClick: (item: OrderLookProduct) => void
  isSelected?: boolean
  isClickable?: boolean
}

export const OrderItemCard: React.FC<OrderItemCardProps> = ({
  item,
  onOrderItemClick,
  isSelected,
  isClickable,
}) => {
  const {id, name, photos} = item.product

  const orderItem = (
    <div className={styles.item}>
      <div className={cx(styles.section, styles.image)}>
        <figure>
          <picture>
            <img alt={name} role="presentation" src={photos[0]} />
          </picture>
        </figure>
      </div>
      <div className={cx(styles.section, styles.details)}>
        <div className={styles.name}>{name}</div>
      </div>
      {isSelected && <Svg src={GreenCheckMark} className={styles.itemCheckmark} />}
    </div>
  )

  if (!name) return null

  if (isClickable && onOrderItemClick) {
    return (
      <button
        key={id}
        onClick={() => onOrderItemClick(item)}
        className={`${isSelected ? styles.buttonSelected : styles.orderItemButton}`}
      >
        {orderItem}
      </button>
    )
  }

  return orderItem
}
